import React, { useState } from "react";
import { Card, PageHeader, Btn } from "../components/UI";
import { FeatureToggleModal } from "../components/FeatureToggleModal";
import { NAV_GROUPS } from "../components/Layout";
import { Plus } from "lucide-react";

/**
 * FeaturesPage — /features route. Simple wrapper that opens the FeatureToggle
 * modal in a fully-page-embedded frame so users can hide/show every sidebar
 * item at once.
 */
export default function FeaturesPage() {
  const [open, setOpen] = useState(true);
  // Only show items the user actually has access to
  const navGroups = NAV_GROUPS.map((g) => ({ label: g.label, items: g.items }));

  return (
    <div className="space-y-6" data-testid="features-page">
      <PageHeader
        eyebrow="Personalize"
        title="Sidebar features"
        subtitle="Hide anything you don't need right now. You can always add features back from this page or the sidebar's + button."
        action={<Btn onClick={() => setOpen(true)} data-testid="features-open-modal-btn"><Plus className="w-4 h-4" /> Manage features</Btn>}
      />
      <Card>
        <div className="text-sm text-slate-300">
          Every sidebar module is optional. Turn off the ones you don&apos;t use to keep your workspace clean — the pre-launch checklist already hides the modules that don&apos;t match your chosen focus (fundraise or advertise).
        </div>
      </Card>
      {open && (
        <FeatureToggleModal
          navGroups={navGroups}
          onClose={() => setOpen(false)}
          onChange={() => { setOpen(false); window.location.reload(); }}
        />
      )}
    </div>
  );
}
